import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  dayAccess: {
    padding: 10,
    backgroundColor: '#e0e0e0',
    height: '100%',
    color: '#606060'
  },
  dayAccessTitle: {
    marginBottom: 20,
    flex: 2,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  dayAccessNumber: {
    flex: 1,

    fontWeight: 'bold',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  dayAccessItemGrid: {
    fontSize: 30
  },
  dayAccessItemPaper: {
    flex: 1,
    padding: 10,
    backgroundColor: '#eceef7',
    height: 100
  },
  dayStars: {
    fontSize: 20,
    color: '#250074'
  },
  progressArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    flexDirection: 'column'
  }
}))

export default useStyles
